// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x0gHNbjMPJeuJf > div[role='presentation'] {
  height: 22px;
}
.x0gHNbjMPJeuJf .hStBegJNcReMyL {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-050, 4px);
  padding: var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-100, 4px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (color) */
  background: linear-gradient(90deg, #c267e7 0%, #fba805 38.46%);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.x0gHNbjMPJeuJf .hStBegJNcReMyL > span[role='img'] {
  width: 18px;
  height: 18px;
}
.x0gHNbjMPJeuJf .ZswOAQumtq2B7v {
  margin-right: var(--ds-space-025, 2px);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 16px;
}
`, ""]);
// Exports
export var lozengeWrapper = `x0gHNbjMPJeuJf`;
export var lozenge = `hStBegJNcReMyL`;
export var text = `ZswOAQumtq2B7v`;
export default ___CSS_LOADER_EXPORT___;
